import * as React from "react";
import type { SVGProps } from "react";
const SvgSectionUpgrade = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m14.125 5.875-8.25 8.25m2.458-8.292 5.792.041.042 5.793"
    />
  </svg>
);
export default SvgSectionUpgrade;
